import { ActionType } from '../BorrowerConstants';
import { LinkType } from '../BorrowerConstants';
import { FeatureType } from '@apply/constants';
import { isFeatureEnabled } from '@apply/store/src/user/types';

export const getActions = (
    item: {
        principalId?: number | null;
        entityId?: number | null;
        companyId?: number | null;
        isDeleted;
        canRecycle;
        canDeleteLink;
        canDelete;
        linkType: LinkType;
        isChildLink: boolean;
    },
    userState
) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions: any[] = [];

    if (!item.isChildLink) {
        if (item.linkType === LinkType.Company) {
            if (!item.isDeleted) {
                actions.push({
                    actionId: ActionType.EditCompany,
                    companyId: item.companyId,
                    text: 'View/Edit',
                    stylingMode: 'contained',
                });
                actions.push({
                    actionId: ActionType.RemoveCompany,
                    companyId: item.companyId,
                    text: 'Recycle Bin',
                    stylingMode: 'contained',
                    disabled: !item.canRecycle,
                });
            } else {
                actions.push({
                    actionId: ActionType.RestoreCompany,
                    companyId: item.companyId,
                    text: 'Restore',
                    stylingMode: 'contained',
                });

                actions.push({
                    actionId: ActionType.DeleteCompany,
                    companyId: item.companyId,
                    text: 'Delete Forever',
                    stylingMode: 'contained',
                    disabled: !item.canDelete,
                });
            }
        }

        if ((!item.linkType || item.linkType === LinkType.Entity) && item.entityId) {
            if (!item.isDeleted) {
                actions.push({
                    actionId: ActionType.EditEntity,
                    entityId: item.entityId,
                    text: 'View/Edit',
                    stylingMode: 'contained',
                });

                actions.push({
                    actionId: ActionType.RemoveEntity,
                    principalId: item.principalId,
                    entityId: item.entityId,
                    text: 'Recycle Bin',
                    stylingMode: 'contained',
                    disabled: !item.canRecycle,
                });
            } else {
                actions.push({
                    actionId: ActionType.RestoreEntity,
                    entityId: item.entityId,
                    text: 'Restore',
                    stylingMode: 'contained',
                });

                actions.push({
                    actionId: ActionType.DeleteEntity,
                    entityId: item.entityId,
                    text: 'Delete Forever',
                    stylingMode: 'contained',
                    disabled: !item.canDelete,
                });
            }

            actions.push({
                actionId: ActionType.EntityAuditHistory,
                entityId: item.entityId,
                text: 'Audit History',
                stylingMode: 'contained',
            });
        }

        if ((!item.linkType || item.linkType === LinkType.Principal) && item.principalId) {
            if (!item.isDeleted) {
                actions.push({
                    actionId: ActionType.EditPrincipal,
                    principalId: item.principalId,
                    entityId: item.entityId,
                    text: 'View/Edit',
                    stylingMode: 'contained',
                });

                if (item.entityId) {
                    actions.push({
                        actionId: ActionType.DeleteBorrowerEntityToPrincipalLink,
                        principalId: item.principalId,
                        entityId: item.entityId,
                        text: 'Remove Entity Link',
                        stylingMode: 'contained',
                        disabled: !item.canDeleteLink,
                    });
                } else if (item.companyId) {
                    actions.push({
                        actionId: ActionType.DeleteBusinessToPrincipalLink,
                        principalId: item.principalId,
                        companyId: item.companyId,
                        text: 'Remove Bus. Link',
                        stylingMode: 'contained',
                        disabled: !item.canDeleteLink,
                    });
                }
            } else {
                actions.push({
                    actionId: ActionType.RestorePrincipal,
                    principalId: item.principalId,
                    text: 'Restore',
                    stylingMode: 'contained',
                });

                actions.push({
                    actionId: ActionType.DeletePrincipal,
                    principalId: item.principalId,
                    text: 'Delete Forever',
                    stylingMode: 'contained',
                    disabled: !item.canDelete,
                });
            }

            if (isFeatureEnabled(userState, FeatureType.Experience)) {
                actions.push({
                    actionId: ActionType.PrincipalExperience,
                    principalId: item.principalId,
                    entityId: item.entityId,
                    text: 'Experience',
                    stylingMode: 'contained',
                });
            }
        }
    } else {
        if (item.entityId && item.principalId) {
            actions.push({
                actionId: ActionType.EditBorrowerEntityToPrincipalLink,
                entityId: item.entityId,
                principalId: item.principalId,
                text: 'Edit Link',
                stylingMode: 'contained',
            });

            actions.push({
                actionId: ActionType.DeleteBorrowerEntityToPrincipalLink,
                entityId: item.entityId,
                principalId: item.principalId,
                text: 'Delete Link',
                stylingMode: 'contained',
                disabled: !item.canDeleteLink,
            });
        }
    }
    return actions;
};
